import React from 'react';
import { makeStyles } from '@material-ui/core/styles';
// import SvgIcon from '@material-ui/core/SvgIcon';

const useStyles = makeStyles((theme) => ({
	root: {
		width: 24,
		height: 24,
		// backgroundColor: '#BCBBD0',

		'& > svg': {
			// margin: theme.spacing(2),
			// width: 24,
			// height: 24,
		},
	},
}));

function CorporationsIcon(props) {
	return (
		<svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
			<path fillRule="evenodd" clipRule="evenodd" d="M5 2C3.34315 2 2 3.34315 2 5V19C2 20.6569 3.34315 22 5 22H16C17.6569 22 19 20.6569 19 19V5C19 3.34315 17.6569 2 16 2H5ZM6 4C5.44772 4 5 4.44771 5 5C5 5.55228 5.44772 6 6 6H7C7.55228 6 8 5.55229 8 5C8 4.44772 7.55228 4 7 4H6ZM5 9C5 8.44771 5.44772 8 6 8L10 8C10.5523 8 11 8.44772 11 9C11 9.55228 10.5523 10 10 10L6 10C5.44772 10 5 9.55228 5 9ZM6 12C5.44772 12 5 12.4477 5 13C5 13.5523 5.44772 14 6 14H10C10.5523 14 11 13.5523 11 13C11 12.4477 10.5523 12 10 12H6ZM6 16C5.44772 16 5 16.4477 5 17C5 17.5523 5.44772 18 6 18H10C10.5523 18 11 17.5523 11 17C11 16.4477 10.5523 16 10 16H6ZM11 5C11 4.44771 11.4477 4 12 4H13C13.5523 4 14 4.44772 14 5C14 5.55229 13.5523 6 13 6H12C11.4477 6 11 5.55228 11 5Z" fill={props.fill} />
			<path opacity="0.5" fillRule="evenodd" clipRule="evenodd" d="M22 3C22.5523 3 23 2.55228 23 2C23 1.44772 22.5523 1 22 1C21.4477 1 21 1.44772 21 2C21 2.55228 21.4477 3 22 3ZM15 9C13.3431 9 12 10.3431 12 12V19C12 20.6569 13.3431 22 15 22H19C20.6569 22 22 20.6569 22 19V12C22 10.3431 20.6569 9 19 9H15Z" fill={props.fill} />
		</svg>
	);
}

export default function SvgIconsColor(props) {
	const classes = useStyles();

	return (
		<div className={classes.root}>
			<CorporationsIcon fill={props.fill} />
		</div>
	);
}